
document.addEventListener('DOMContentLoaded', function() {
  // Sadece ürün sayfasında çalış
  var buySection = document.querySelector('buy-buttons');
  if (!buySection) return;

  // Sticky bar oluştur
  var bar = document.createElement('div');
  bar.className = 'ms-sticky-bar';

  var priceEl = document.querySelector('product-price .money, [class*="price"] .money, product-price');
  var titleEl = document.querySelector('h1');
  var price = priceEl ? priceEl.textContent.trim() : '';
  var title = titleEl ? titleEl.textContent.trim() : '';

  bar.innerHTML = '<div class="ms-sticky-inner">' +
    '<div class="ms-sticky-info">' +
      '<div class="ms-sticky-title">' + title + '</div>' +
      '<div class="ms-sticky-price">' + price + '</div>' +
    '</div>' +
    '<button class="ms-sticky-btn" id="ms-sticky-btn">Sepete Ekle</button>' +
  '</div>';

  document.body.appendChild(bar);

  // Tıklayınca asıl butona tıkla
  document.getElementById('ms-sticky-btn').addEventListener('click', function() {
    var btn = document.querySelector('buy-buttons button[name="add"], buy-buttons button[type="submit"], buy-buttons .button');
    if (btn) btn.click();
  });

  // Scroll'a göre göster/gizle
  function checkScroll() {
    var rect = buySection.getBoundingClientRect();
    // buy-buttons ekranın altına geçince göster
    if (rect.bottom < 0 || rect.top > window.innerHeight) {
      bar.classList.add('ms-sticky-bar--visible');
    } else {
      bar.classList.remove('ms-sticky-bar--visible');
    }
  }

  window.addEventListener('scroll', checkScroll, { passive: true });
  checkScroll();
});

// Kisiselleştirme formunu buy-buttons form'una enjekte et
document.addEventListener('DOMContentLoaded', function() {
  var buyForm = document.querySelector('buy-buttons form, form[action="/cart/add"], product-form form');
  var kisinForm = document.getElementById('ms-kisi-form');
  if (!buyForm || !kisinForm) return;

  function injectProperties() {
    // Önce eskilerini temizle
    buyForm.querySelectorAll('input[data-ms-prop]').forEach(function(el) { el.remove(); });

    // Tüm form field'larını kopyala
    var fields = kisinForm.querySelectorAll('input[name], select[name]');
    fields.forEach(function(field) {
      if (field.type === 'file') return;
      var hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = field.name;
      hidden.value = field.value;
      hidden.setAttribute('data-ms-prop', '1');
      buyForm.appendChild(hidden);
    });
  }

  // Her değişiklikte güncelle
  kisinForm.addEventListener('change', injectProperties);
  kisinForm.addEventListener('input', injectProperties);

  // Submit anında da güncelle
  buyForm.addEventListener('submit', injectProperties, true);
  document.addEventListener('click', function(e) {
    if (e.target.closest('buy-buttons button[type="submit"]')) {
      injectProperties();
    }
  }, true);
});
